import { render, staticRenderFns } from "./TravellerInterests.vue?vue&type=template&id=36521ad4&lang=pug&"
import script from "./TravellerInterests.vue?vue&type=script&lang=js&"
export * from "./TravellerInterests.vue?vue&type=script&lang=js&"
import style0 from "./TravellerInterests.vue?vue&type=style&index=0&id=36521ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports